import React, {useState} from "react";

interface MastTooltipProps {
  show: boolean;
}

const MastTooltip: React.FC<MastTooltipProps> = ({show}) => {
  const [visible, setVisible] = useState(false);

  if (!show) return null;

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        cursor: "pointer",
      }}
      onMouseEnter={() => {
        setVisible(true);
      }}
      onMouseLeave={() => {
        setVisible(false);
      }}>
      <span
        style={{
          display: "inline-block",
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: "red",
        }}
      />

      {visible && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "100%",
            marginLeft: 8,
            transform: "translateY(-50%)",
            minWidth: 180,
            maxWidth: 600,
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "ellipsis",
            wordBreak: "normal",
            overflowWrap: "break-word",
            zIndex: 9999,
            backgroundColor: "#333",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: 4,
            fontSize: 12,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            textAlign: "left",
          }}>
          This mast has been accepted, hence its properties and related elements cannot be modified
        </div>
      )}
    </div>
  );
};

export default MastTooltip;
